import React from "react";
import { Link, useSearchParams } from "react-router-dom";

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const orderNumber = searchParams.get("order_number");

  return (
    <div>
      <nav className="navbar navbar-default navbar-fixed-top">
        <div className="container">
          <div className="navbar-header">
            <Link className="navbar-brand" to="/">
              By The App
            </Link>
          </div>
        </div>
      </nav>

      <main className="payment-result-page">
        <div className="container">
          <div className="payment-result-card payment-result-success">
            <div className="payment-result-icon" aria-hidden="true">
              ✓
            </div>
            <h1>Payment Successful</h1>
            <p>
              Thank you — your payment has been received. The business has been notified
              and will confirm your order shortly.
            </p>
            {orderNumber && (
              <p className="payment-result-order">
                Order number: <strong>{orderNumber}</strong>
              </p>
            )}
            <p className="payment-result-note">
              You may receive a confirmation by text or email if you opted in during your
              call.
            </p>
            <Link to="/" className="btn btn-custom btn-lg">
              Back to Home
            </Link>
          </div>
        </div>
      </main>

      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2026 ByTheApp. All rights reserved.{" "}
            <a href="mailto:info@bytheapp.com">info@bytheapp.com</a>
            {" · "}
            <Link to="/privacy">Privacy Policy</Link>
            {" · "}
            <Link to="/terms">Terms</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
